module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-slider"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.products), function(product, key) {
    return _c('swiper-slide', {
      key: key
    }, [_c('div', {
      staticClass: "product__inner"
    }, [_c('div', {
      staticClass: "product__leftside"
    }, [_c('a', {
      staticClass: "acer-logo",
      attrs: {
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/pages/product/acer-logo.png",
        "alt": "acer"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product__img"
    }, [_c('img', {
      attrs: {
        "src": product.mainImg,
        "alt": product.mainImg
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product__content product__content--nomg"
    }, [_c('h2', {
      staticClass: "product__name"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.name)
      }
    })]), _vm._v(" "), _c('h3', {
      staticClass: "product__price"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.price)
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "product__link btn",
      attrs: {
        "href": product.link,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.$root.gaSend('product', 'click', product.name)
        }
      }
    }, [_vm._v("Купить")])])]), _vm._v(" "), _c('div', {
      staticClass: "product__rightside",
      style: ({
        'backgroundImage': (_vm.$root.isMobile) ? 'url(' + _vm.bg + ')' : ''
      })
    }, [_c('div', {
      staticClass: "product__content"
    }, [_c('h1', {
      staticClass: "product__title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(product.title)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "product__description",
      domProps: {
        "innerHTML": _vm._s(product.description)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "product__features"
    }, _vm._l((product.features), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "product__features-item"
      }, [(item.img) ? _c('img', {
        attrs: {
          "src": '/static/svg/icons/' + item.img + '.svg',
          "alt": "icon"
        }
      }) : _vm._e(), _vm._v(" "), (item.title) ? _c('h3', {
        staticClass: "item-title"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.title)
        }
      })]) : _vm._e(), _vm._v(" "), (item.description) ? _c('h4', {
        staticClass: "item-undertitle"
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(item.description)
        }
      })]) : _vm._e()])
    }))])])])
  })), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
    staticClass: "next-slide"
  }, [_c('arrow-next')], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
    staticClass: "prev-slide"
  }, [_c('arrow-prev')], 1) : _vm._e(), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "product__navigation navi"
  }, [_c('div', {
    staticClass: "navi__leftside"
  }, [_c('div', {
    staticClass: "swiper-pagination swiper-pagination-bullets",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })]), _vm._v(" "), _c('div', {
    staticClass: "navi__rightside"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3038975f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/product/productSlider.vue
// module id = 642
// module chunks = 1